import React from "react";
import './Technology.css';
const Technology = () => {
    const [activeTab, setActiveTab] = React.useState('services');

    // サービス一覧データ
    const services = [
        {
            icon: '',
            title: 'Google広告運用',
            description: 'リスティング広告・ディスプレイ広告・YouTube広告まで、Google広告を総合的に運用。',
            features: ['キーワード戦略設計', 'A/Bテスト実施', '入札最適化', 'レポート分析']
        },
        {
            icon: '',
            title: 'GoogleMap MEO対策',
            description: 'Googleマップでの上位表示を実現し、地域での認知度と集客力を向上させます。',
            features: ['ビジネスプロフィール最適化', '口コミ管理', '写真・投稿管理', '競合分析']
        },
        {
            icon: '',
            title: 'Meta/SNS広告運用',
            description: 'Facebook・Instagram広告で、ターゲット層に効果的にリーチします。',
            features: ['オーディエンス設計', 'クリエイティブ制作支援', 'カタログ広告', 'コンバージョン最適化']
        },
        {
            icon: '',
            title: 'キーワード戦略設計',
            description: '地域特性を考慮したキーワード選定で、質の高いアクセスを獲得します。',
            features: ['競合調査', '検索意図分析', '除外キーワード設定', 'CVキーワード発掘']
        },
        {
            icon: '',
            title: 'LP改善提案',
            description: 'ランディングページの改善提案で、広告のコンバージョン率を最大化します。',
            features: ['ヒートマップ分析', 'UI/UX改善案', 'ABテスト設計', 'フォーム最適化']
        },
        {
            icon: '',
            title: 'レポート自動化・PDCA',
            description: '定期レポートと改善提案で、継続的な成果向上をサポートします。',
            features: ['自動レポート配信', 'データ可視化', '改善アクション提案', '月次ミーティング']
        }
    ];

    // 運用の流れ
    const flowSteps = [
        {
            step: '01',
            title: '　無料相談・ヒアリング',
            description: '　 ビジネスの課題や目標を丁寧にヒアリング。金沢エリアなら現地訪問も可能です。',
            icon: ''
        },
        {
            step: '02',
            title: '　戦略設計・提案',
            description: '　 ヒアリング内容を基に、最適な広告戦略と予算配分をご提案します。',
            icon: ''
        },
        {
            step: '03',
            title: '　広告アカウント構築',
            description: '　 キーワード選定、広告文作成、ターゲティング設定など、初期構築を実施。',
            icon: ''
        },
        {
            step: '04',
            title: '　運用開始・最適化',
            description: '　 広告配信を開始し、データを基にした継続的な改善・最適化を実施します。',
            icon: ''
        },
        {
            step: '05',
            title: '　定期レポート・改善提案',
            description: '　 月次レポートと改善提案を通じて、成果の向上を継続的にサポートします。',
            icon: ''
        }
    ];

    // 他社との比較
    const comparisonData = [
        {
            feature: '地域密着対応',
            us: '◎ 金沢エリア現地訪問可',
            others: '△ オンラインのみ'
        },
        {
            feature: '運用担当者',
            us: '◎ Google広告認定資格保有',
            others: '△ 資格なし/不明'
        },
        {
            feature: '戦略設計',
            us: '◎ 経営視点×技術視点の両立',
            others: '○ 技術面のみ'
        },
        {
            feature: 'レポート',
            us: '◎ カスタムレポート＋月次ミーティング',
            others: '○ 定型レポートのみ'
        },
        {
            feature: '改善サイクル',
            us: '◎ 伴走型PDCA',
            others: '△ 単発改善'
        }
    ];

    return (
        <section className="technology">
            <div className="technology-decorations">
                <div className="tech-decoration-circle tech-circle-blue"></div>
                <div className="tech-decoration-circle tech-circle-purple"></div>
            </div>

            <div className="technology-container">
                {/* セクションヘッダー */}
                <div className="technology-header">
                    <div className="section-badge">提供サービス</div>
                    <h2 className="technology-title">
                        具体的に何をしてくれるの？
                    </h2>
                    <p className="technology-subtitle">
                        Google広告からMEO、SNS広告まで。あなたのビジネスに最適化した<br />
                        総合的なWeb広告運用サービスをご提供します。
                    </p>
                </div>

                {/* タブナビゲーション */}
                <div className="technology-tabs">
                    <button 
                        className={`tech-tab ${activeTab === 'services' ? 'active' : ''}`}
                        onClick={() => setActiveTab('services')}
                    >
                        <span className="tab-icon"></span>
                        提供サービス
                    </button>
                    <button 
                        className={`tech-tab ${activeTab === 'flow' ? 'active' : ''}`}
                        onClick={() => setActiveTab('flow')}
                    >
                        <span className="tab-icon"></span>
                        運用の流れ
                    </button>
                    <button 
                        className={`tech-tab ${activeTab === 'comparison' ? 'active' : ''}`}
                        onClick={() => setActiveTab('comparison')}
                    >
                        <span className="tab-icon"></span>
                        他社との違い
                    </button>
                </div>

                {/* タブコンテンツ */}
                <div className="technology-content">
                    {/* 提供サービス */}
                    {activeTab === 'services' && (
                        <div className="services-content">
                            <div className="services-grid">
                                {services.map((service, index) => (
                                    <div key={index} className="service-card">
                                        <div className="service-icon">{service.icon}</div>
                                        <h3 className="service-title">{service.title}</h3>
                                        <p className="service-description">{service.description}</p>
                                        <ul className="service-features">
                                            {service.features.map((feature, fIndex) => (
                                                <li key={fIndex}>
                                                    <span className="feature-check">✓</span>
                                                    {feature}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                ))}
                            </div>
                            <div className="services-note">
                                <p><strong>金沢エリアなら現地訪問対応可能</strong>。対面でのご相談や、現場での改善提案も可能です。</p>
                            </div>
                        </div>
                    )}

                    {/* 運用の流れ */}
                    {activeTab === 'flow' && (
                        <div className="flow-content">
                            <div className="flow-steps">
                                {flowSteps.map((step, index) => (
                                    <div key={index} className="flow-step">
                                        <div className="flow-step-number">{step.step}</div>
                                        <div className="flow-step-icon">{step.icon}</div>
                                        <div className="flow-step-content">
                                            <h3 className="flow-step-title">{step.title}</h3>
                                            <p className="flow-step-description">{step.description}</p>
                                        </div>
                                        {index < flowSteps.length - 1 && (
                                            <div className="flow-arrow">↓</div>
                                        )}
                                    </div>
                                ))}
                            </div>
                            <div className="flow-support">
                                <h4>伴走型サポート</h4>
                                <p>初期構築から運用開始後まで、一貫してサポート。月次ミーティングで成果を共有し、次のアクションを明確にします。</p>
                            </div>
                        </div>
                    )}

                    {/* 他社との比較 */}
                    {activeTab === 'comparison' && (
                        <div className="comparison-content">
                            <div className="comparison-table">
                                <div className="comparison-header">
                                    <div className="comparison-cell comparison-cell-feature">比較項目</div>
                                    <div className="comparison-cell comparison-cell-us">当サービス</div>
                                    <div className="comparison-cell comparison-cell-others">一般的な広告代理店</div>
                                </div>
                                {comparisonData.map((item, index) => (
                                    <div key={index} className="comparison-row">
                                        <div className="comparison-cell comparison-cell-feature">
                                            {item.feature}
                                        </div>
                                        <div className="comparison-cell comparison-cell-us">
                                            {item.us}
                                        </div>
                                        <div className="comparison-cell comparison-cell-others">
                                            {item.others}
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div className="comparison-footer">
                                <div className="comparison-highlight">
                                    <h4>最大の差別化ポイント</h4>
                                    <p className="highlight-text">
                                        「石川県/金沢エリアコーディネーター」×「Google広告認定資格保有者」のツーマンセル体制
                                    </p>
                                    <p>公的信頼性と専門技術の両方を兼ね備えた、他にはない支援体制です。</p>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </section>
    );
};

export default Technology;